const index = "account";

export const accountEndpoint = Object.freeze({
  account: index,
  forAssignment: `${index}/for-assignment`,
  me: `${index}/me`,
  resendInvite: `${index}/resend-invite`,
  requestEmailUpdate: `${index}/request-email-update`,
  changePassword: `${index}/change-password`,
  checkUser: `${index}/check-user`,
});
